module.exports = __webpack_public_path__ + "static/img/xl_role.d9de0b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/xl_role.png
// module id = FJ+h
// module chunks = 7